<template>
  <div id="app">
    <elevator :modal="whichModal" />
    <router-view @setComics="setComics" @openModal="openModal" />
    <modal :which="whichModal" :comics="comics" :popups="popups" @closeModal="closeModal" />
  </div>
</template>

<script>
import Elevator from '@/components/Elevator';
import Modal from '@/components/Modal';
import callApi from '@/helpers/callApi';

export default {
  name: 'App',
  data() {
    return {
      whichModal: '',
      comics: [],
      fromApi: [],
      popups: [],
      retry: 0,
    };
  },
  components: { Elevator, Modal },
  methods: {
    setComics(comics) { this.comics = comics; },
    getPopups() {
      callApi.getPopups((r) => {
        // In the event of a problem, try again up to three times.
        if (r === 'ERROR' && this.retry < 3) {
          this.retry += 1;
          this.getPopups();
          return;
        }

        // Get all popups from API.
        try {
          this.fromApi = JSON.parse(r).entries;
        } catch (e) {
          this.fromApi = r;
          return;
        }

        // Load popups into array.
        for (let i = 0; i < this.fromApi.length; i += 1) {
          const p = this.fromApi[i];
          this.popups.push({ title: `${p.title}`, images: p.images });
        }
      });
    },
    openModal(which) { this.whichModal = which; },
    closeModal() { this.whichModal = ''; },
    resizeBody() {
      const pageBody = this.$el.querySelector('#app > div:nth-child(2)');
      const bodySize = pageBody.offsetHeight || 1440;
      const headHeight = this.$el.querySelector('.elevator__top').offsetHeight || 125;
      const windowHeight = Math.min(window.innerHeight, window.innerWidth * 1.7) - headHeight;
      const windowWidth = Math.min(window.innerWidth, window.innerHeight * 1.5);

      const scale = Math.max(windowHeight, windowWidth) / bodySize;
      let offsetX = (windowWidth - (scale * bodySize)) / 2;
      let offsetY = ((windowHeight - (scale * bodySize)) / 2) + headHeight;

      // Room-specific offset.
      // istanbul ignore else
      if (pageBody === this.$el.querySelector('.home')) {
        const keep = [361 * scale, (358 * scale) - headHeight];
        if (offsetX < -keep[0]) { offsetX = -keep[0]; }
        if (offsetY < -keep[1]) { offsetY = -keep[1]; }
      }

      if (windowWidth < window.innerWidth) {
        offsetX += (window.innerWidth - windowWidth) / 2;
      }

      pageBody.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
    },
    keyHandle(e) {
      const key = e.keyCode ? e.keyCode : e.which;
      if (key === 27) this.closeModal(); // ESCAPE
    },
  },
  mounted() {
    window.addEventListener('keydown', this.keyHandle);
    window.addEventListener('resize', this.resizeBody);
    this.resizeBody();
    this.getPopups();
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.keyHandle);
    window.removeEventListener('resize', this.resizeBody);
  },
};
</script>

<style>
  html, body {
    position: relative;
    height: 100%;
    margin: 0;
    overflow: hidden;
    background: url(./assets/nav/margin-tile.png) repeat;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue